import React from 'react';
import Layout from '../components/layout';
import SEO from '../components/seo';
import EvolvedImage from '../components/EvolvedImage';
import { MenuItem } from '../components/Menu/Types';
import { AffiliateProgramsProvider } from '../context/AffiliateProgramsContext';
import { Content } from '../components/Content';

type File = {
  fileName: string;
};

type FeatureImage = {
  file: File;
  description: string;
};
export interface PageContext {
  richTextContent: any;
  metaTitle: string;
  metaDescription: string;
  featureImage: FeatureImage;
  mainMenuItems: [MenuItem];
  affiliatePrograms: any;
}

interface Props {
  pageContext: PageContext;
  data: any;
}

export default function Page({
  pageContext: {
    richTextContent,
    metaTitle,
    metaDescription,
    featureImage,
    mainMenuItems,
    affiliatePrograms,
  },
}: Props): JSX.Element {
  const hasFeatureImage =
    featureImage && featureImage.file && featureImage.file.fileName;
  return (
    <Layout menuItems={mainMenuItems}>
      <SEO title={metaTitle} metaDescription={metaDescription} />
      {hasFeatureImage && (
        <EvolvedImage
          fileName={featureImage.file.fileName}
          alt={featureImage.description || ''}
        />
      )}
      <AffiliateProgramsProvider affiliatePrograms={affiliatePrograms}>
        <Content richTextContent={richTextContent} />
      </AffiliateProgramsProvider>
    </Layout>
  );
}
